/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marker_Import_Supported_Formats_LabelInputs */



/**
* | output |
* | --- |
* | "Supported formats: JSON, EDL" |
*
* @param {Marker_Import_Supported_Formats_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const marker_import_supported_formats_label = /** @type {((inputs?: Marker_Import_Supported_Formats_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marker_Import_Supported_Formats_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Formats pris en charge : JSON, EDL")
	if (locale === "de") return /** @type {LocalizedString} */ ("Unterstützte Formate: JSON, EDL")
	if (locale === "it") return /** @type {LocalizedString} */ ("Formati supportati: JSON, EDL")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Поддерживаемые форматы: JSON, EDL")
	if (locale === "es") return /** @type {LocalizedString} */ ("Formatos admitidos: JSON, EDL")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("支持的格式：JSON、EDL")
	if (locale === "ja") return /** @type {LocalizedString} */ ("サポートされている形式: JSON、EDL")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समर्थित प्रारूप: JSON, EDL")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Formatos suportados: JSON, EDL")
	return /** @type {LocalizedString} */ ("Supported formats: JSON, EDL")
});